export const NAV_ITEMS = [
    { title: 'Популярное', query: '?order=NUM_VOTE&type=FILM' },
    {
        title: 'Новинки',
        query: '?yearFrom=2022&type=FILM',
    },
    {
        title: 'Топ',
        query: '?order=RATING&type=FILM',
    },
];
